import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import classNames from 'classnames';
import { AssetShareType } from '../../entities/ShareItem';
import { useIsMobile } from '../Mui3WidthProvider';
import FacebookThumbnail from '../../resources/facebook-thumb.png';
import VimeoThumbnail from '../../resources/vimeo-thumb.png';
import YouTubeThumbnail from '../../resources/youtube-thumb.png'
import { RenderVimeo } from './RenderVimeo';
import { RenderYoutube } from './RenderYoutube';
import { RenderFacebook } from './RenderFacebook';

const useStyles = makeStyles(() => ({
    closeMobileIcon: {
        color: "rgb(0, 0, 0, .4)",
        position: "absolute",
        top: 10,
        right: 10
    },
    listHorizontal: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
    },
    thumbnailListItem: {
        width: 105,
        marginLeft: 5,
        marginRight: 5
    },
    socialThumnails: {
        marginTop: -5
    },
    listItemSubContainer: {
        textAlign: 'center'
    },
    fakeAnchor: {
        textDecoration: 'underline',
        color: '#0000EE'
    },
    clickable: {
        cursor: 'pointer',
        "&:hover": {
            opacity: .8
        }
    }
}));

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export function ShareVideoDialog(props:Props){
    const isMobile = useIsMobile();
    const classes = useStyles()

    const [addVideoType, setAddVideoType] = useState<AssetShareType>(AssetShareType.None);

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            fullWidth
            fullScreen={isMobile}
        >
            <DialogTitle id="form-dialog-title">Share a video message
                    {isMobile && <CloseIcon className={classes.closeMobileIcon} onClick={props.onClose} />}
            </DialogTitle>
            <DialogContent>
                <div style={{ marginBottom: 26 }}>
                    <strong>Step 1</strong>: Add your video to YouTube, Facebook, or Vimeo&nbsp;<a href="https://sermonmaker.net/help/add-video-youtube-vimeo-facebook/" rel="noopener noreferrer" target="_blank">Learn how</a>
                </div>
                <div style={{ marginBottom: 26 }}>
                    <strong>Step 2</strong>: Select your video service below
                </div>
                <div style={{ maxWidth: 360, marginBottom: 8 }}>
                    <List className={classes.listHorizontal}>
                        <ListItem 
                            onClick={() => setAddVideoType(AssetShareType.YouTube)} 
                            style={{ opacity: (addVideoType !== AssetShareType.None && addVideoType !== AssetShareType.YouTube) ? .2 : 1 }} 
                            className={classNames(classes.thumbnailListItem, classes.clickable)}
                        >
                            <div className={classes.listItemSubContainer}>
                                <img alt="Youtube" className={classes.socialThumnails} src={YouTubeThumbnail} />
                                <span className={classes.fakeAnchor}>YouTube</span>
                            </div>
                        </ListItem>
                        <ListItem 
                            onClick={() => setAddVideoType(AssetShareType.Facebook)}
                            style={{ opacity: (addVideoType !== AssetShareType.None && addVideoType !== AssetShareType.Facebook) ? .2 : 1 }}
                            className={classNames(classes.thumbnailListItem, classes.clickable)}
                        >
                            <div className={classes.listItemSubContainer}>
                                <img alt="Facebook" className={classes.socialThumnails} src={FacebookThumbnail} />
                                <span className={classes.fakeAnchor}>Facebook</span>
                            </div>
                        </ListItem>
                        <ListItem 
                            onClick={() => setAddVideoType(AssetShareType.Vimeo)}
                            style={{ opacity: (addVideoType !== AssetShareType.None && addVideoType !== AssetShareType.Vimeo) ? .2 : 1 }}
                            className={classNames(classes.thumbnailListItem, classes.clickable)}
                        >
                            <div className={classes.listItemSubContainer}>
                                <img alt="Vimeo" className={classes.socialThumnails} src={VimeoThumbnail} />
                                <span className={classes.fakeAnchor}>Vimeo</span>
                            </div>
                        </ListItem>
                    </List>
                </div>
                {addVideoType === AssetShareType.Vimeo && <RenderVimeo onClose={props.onClose} />}
                {addVideoType === AssetShareType.YouTube && <RenderYoutube onClose={props.onClose} />}
                {addVideoType === AssetShareType.Facebook && <RenderFacebook onClose={props.onClose}/>}
            </DialogContent>
        </Dialog>
    )
}